import React, { useState, useEffect } from 'react';
import EncaissementListTable from '../encaissement_list/EncaissementListTable';
import { getEncaissementsRecep, clearEncaissements } from '../../flux/actions/encaissementActions';
import { getAllSocietes, clearSocietes } from '../../flux/actions/societeActions';
import { Container, Row, Col, Label, FormGroup, Button, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IEncRecepListContainer, IEncaissementListReduxProps } from '../../types/interfaces';
import Select from 'react-select';
import { useBeforeunload } from 'react-beforeunload';
import Durations from '../Durations';
import Loading from '../Loading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard, faExclamationCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';
import { useAlert } from "react-alert";
import { constants } from '../../types/constants';

const EncRecepListContainer = ({ 
  getEncaissementsRecep,
  clearEncaissements,
  encaissement,
  getAllSocietes,
  clearSocietes,
  societe,
  auth
 }: IEncRecepListContainer) => {
  const alert = useAlert();
  const { encaissements, loading } = encaissement;
  const { societes, loading: loadingS } = societe;
  const [tableData, setTableData] = useState(encaissements);
  const [filteredRows, setFilteredRows] = useState(encaissements);
  const selectOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const [societeValue, setSocieteValue] = useState<any>('');
  const [selectedDuration, setSelectedDuration] = useState('');
  const [selectedRows, setSelectedRows] = useState(Array());
  const [clearFilters, setClearFilters] = useState(false);
  const [showAllValue, setShowAllValue] = useState(true);
  const [includeNextOnes, setIncludeNextOnes] = useState(false);
  
  const changeShowAllHandle = (e) => {
    setShowAllValue(e.target.checked);
  };

  useBeforeunload((e) => {
    if(selectedRows.length)
      e.preventDefault();
  });

  useEffect(() => {
    refresh();
  }, [getEncaissementsRecep, selectedDuration, societeValue, showAllValue, includeNextOnes]);

  const refresh = () => {
    if(societeValue)
      getEncaissementsRecep(selectedDuration, societeValue["id"], societeValue["LIBELE"], showAllValue ? 1 : 0, includeNextOnes ? 1 : 0);
    else
      clearEncaissements();
  }

  useEffect(() => {
    getAllSocietes();
  }, [getAllSocietes]);

  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }

  useEffect(() => {
    return () => {
      clearEncaissements();
      clearSocietes();
    }
  }, []);

  useEffect(() => {
    setTableData(encaissements);
  }, [encaissements]);

  const copy = () => {
    const rows = encaissements.filter(e => e.MODE_REGL === constants.MODE_REGL_CHEQUE).map(e => [
      e.contrat_encaissements?.length ? (e.contrat_encaissements[e.contrat_encaissements.length - 1].contrat?.PROJET || "") : "",
      "",
      e.contrat_encaissements?.length ? (e.contrat_encaissements[e.contrat_encaissements.length - 1].contrat?.NUM_DOSS || "") : "",
      (e.REF_REGLEMENT || "").trim(),
      e.DATE_PORTEFEUILLE ? new Date(e.DATE_PORTEFEUILLE).toISOString().split('T')[0] : "",
      (e.BANQUE || "").trim(),
      (e.TIRE_PAR || "").trim(),
      Number((e.MONTANT || 0).toFixed(2)),
      e.DATE_REGLEMENT ? new Date(e.DATE_REGLEMENT).toISOString().split('T')[0] : "",
      "",
      "",
      "",
      "",
      "",
      e.date_reception ? new Date(e.date_reception).toISOString().split('T')[0] : "",
      // "",
      // "",
      // "",
      // "",
      // "",
      // "",
    ]).map(row => row.join('\t')).join('\n')
    navigator.clipboard.writeText(rows).then(() => {
      alert.success("Lignes copiées dans le presse-papiers ! Collez-les dans Excel.");
    }).catch(err => {
      console.error("Failed to copy data:", err);
      alert.error("Erreur Copie")
    });
  }

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col sm="12" md="6"><h2 className="title">Encaissements Réceptionnés</h2></Col>
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="societes">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
              <Select
                id="societes"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Chercher par nom...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                options={selectOptions}
                isDisabled={loading}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className="justify-content-center justify-content-md-end" style={{alignItems: "center"}}>
          <CustomInput type="switch" id="includeNextOnes" name="includeNextOnesSwitch" label="Inclure les encaissements traités après réception" disabled={loading} checked={includeNextOnes} onChange={e => setIncludeNextOnes(e.target.checked)} />
        </Row>
      </Container>
      <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: "6px"}} />
      {loading ? <Loading topSpace /> : <EncaissementListTable encaissementsData={tableData} setTableData={setTableData} setFilteredRows={setFilteredRows} showProjectColumn={societeValue?.id === "ALL"} showStatutColumn={true} />}
      <Container>
        <Row>
          <Col xs="12" sm="5">
            <FormGroup>
              <Button
                className="btn btn-info confirmBtn"
                onClick={copy}
                ><FontAwesomeIcon icon={faClipboard} />&nbsp;&nbsp;Copier les lignes Excel (Chèques)</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state: IEncaissementListReduxProps) => ({
  encaissement: state.encaissement,
  societe: state.societe,
  auth: state.auth
});

export default connect(mapStateToProps, { getEncaissementsRecep, clearEncaissements, getAllSocietes, clearSocietes })(EncRecepListContainer);
